import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface BackPrePlanState extends ListState<any> {
    stockmodel: any;
    id: number;
}

class BackPrePlanMutations extends ListMutations<any> {
}

class BackPrePlan extends ListModule<BackPrePlanState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        stockmodel: {} as any,
        id: 0
    }

    actions = {
        // ��ȡԤ���ƻ��б�
        async getAll(context: ActionContext<BackPrePlanState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/PrePlan/GetList', { params: payload.data });
            context.state.loading = false;
            const page = response.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        // ����/�༭Ԥ���ƻ�
        async create(context: ActionContext<BackPrePlanState, any>, payload: any) {
            await Ajax.post('/api/services/app/PrePlan/Create', payload.data);
        },

        // ɾ��Ԥ���ƻ�
        async delete(context: ActionContext<BackPrePlanState, any>, payload: any) {
            await Ajax.post(`/api/services/app/PrePlan/Delete?id=${payload.data.id}`);
        }
    };

    mutations = {
        setCurrentPage(state: BackPrePlanState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackPrePlanState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setModel(state: BackPrePlanState, model: any) {
            state.stockmodel = model;
        }
    }
}

const backPrePlan = new BackPrePlan();
export default backPrePlan;